import { Component, EventEmitter } from "@angular/core";
import { UntypedFormGroup, FormBuilder, FormGroup, Validators, FormControl, ReactiveFormsModule, ValidatorFn, AbstractControl } from "@angular/forms";
import { SvgIconComponent } from "@app/components/utils/svg-icon/svg-icon.component";
import { NetDbNjdbpawebbService } from "@app/service/njdbpawebb/net-db-njdbpawebb.service";
import { NvdbNavigationService } from "@app/service/nvdb-navigation.service";
import { TrvMapExtensionService } from "@app/service/trv-map-extension.service";
import { svgCircleInfo } from "@app/shared/utils/svg-helper-data";
import { NvdbReportStyle } from "@app/trv-map-extension/trv-map-extension-styles";
import { PinPurpleInfoStyle, TrvNgMapService } from "@trafikverket/trv-ng-map";
import { Duration } from "luxon";
import { TrvFormBundle, TrvFormComponent, TrvFormUtilityService, TrvFormValidationErrorMap, TrvGlobalMessagesComponent, TrvGlobalMessagesService, TrvModalConfig, TrvModalService } from "@trv-hub/trv-ng-common";

@Component({
    selector: "app-bandel-search",
    imports: [TrvFormBundle, ReactiveFormsModule, SvgIconComponent],
    templateUrl: "./bandel-search.component.html",
    styleUrl: "./bandel-search.component.scss"
})
export class BandelSearchComponent {
    public closeEmitter: EventEmitter<void> = new EventEmitter<void>();

    public form: UntypedFormGroup;

    protected readonly circleInfoIcon = svgCircleInfo;

    validationErrorMap: TrvFormValidationErrorMap = {
        input1: {
            required: "Måste anges.",
            numbersOnly: "Ange bandelsnr kmtal+meter i hundratal",
        },
        input2: {
            numbersOnly: "Ange bandelsnr kmtal+meter i hundratal",
        },
    };

    get input1() {
        return this.form.get("input1") as FormControl;
    }

    get input2() {
        return this.form.get("input2") as FormControl;
    }

    constructor(
        public trvMapExtenstionService: TrvMapExtensionService,
        private formBuilder: FormBuilder,
        private netdbService: NetDbNjdbpawebbService,
        private trvMapService: TrvNgMapService,
        private nvdbNavigationService: NvdbNavigationService,
        private trvModalService: TrvModalService,
        private formUtilityService: TrvFormUtilityService,
        private globalMessagesService: TrvGlobalMessagesService
    ) {
        this.form = formBuilder.group({});
        this.form = new FormGroup({
            input1: new FormControl("", [Validators.required, numbersOnly()]),
            input2: new FormControl("", numbersOnly()),
        });
    }

    ngOnInit(): void { }

    public close() {
        this.closeEmitter.emit();
    }

    public zoomTo() {
        if (this.form.valid) {
            this.netdbService
                .bandelSearch({
                    toBandel: this.input1.value,
                    fromBandel: this.input2.value,       
                })
                .subscribe(_res => {
                    let res = JSON.parse(_res);
                    console.log(res);
                    const trvMap = this.trvMapService.trvMap!;
                    trvMap.trvLayer.tempLayer!.getSource()?.clear();

                    if (res.To) {
                        const featureTo = trvMap.trvLayer.getFeatureFromWkt(res.To.BandelWKT);
                        featureTo.setStyle(PinPurpleInfoStyle);
                        trvMap.trvLayer.addFeature(featureTo, trvMap.trvLayer.tempLayer!);
                    } else {
                        this.globalMessagesService.error("Hittade inget resultat för \"till\"")
                    }

                    if (res.From) {
                        const featureFrom = trvMap.trvLayer.getFeatureFromWkt(res.From.BandelWKT);
                        featureFrom.setStyle(PinPurpleInfoStyle);
                        trvMap.trvLayer.addFeature(featureFrom, trvMap.trvLayer.tempLayer!);
                    } else {
                        if (this.input2.value != "")
                        this.globalMessagesService.error("Hittade inget resultat för \"från\"")
                    }

                    trvMap.zoomInOnLayer(trvMap.trvLayer.tempLayer!, 500, this.nvdbNavigationService.getPaddingForZoomToExtentOnMainMap(300));
                });
        } else {
            this.formUtilityService.isValid(this.form)
            this.globalMessagesService.error("Fel angivet formulär")
        }
    }

    public openInfo() {
        const config: TrvModalConfig = {
            disposeOnBackdropClick: true,
        };

        if (this.nvdbNavigationService.isMobileDevice) config.size = "fullscreen";
        this.trvModalService.info("Information om funktionen \"Zooma till bandel\"", "Ange bandelsnr kmtal + meter i hela hundratal <br> Ex. <b>303 1+100</b><br><i>Endast fältet \"till\" är obligatoriskt.</i>", config);
    }
}



export function numbersOnly(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
        const regex = /^\d+ \d+\+(0|[1-9]\d*00)$/;
        const value = control.value;
        const valid = value === '' || regex.test(value);
        return valid ? null : { numbersOnly: true };
    };
}